import { useState, useContext } from "react";
import {
  Container,
  makeStyles,
  Box,
  Typography,
  Button,
} from "@material-ui/core";
import SampleList from "./sample-list";
import DoctorList from "./doctor-list";
import { useAssignToDoctor } from "../../hooks/useAssignToDoctor";
import { Loader, Toast } from "../../components";
import AssignList from "./assign";
import AssignmentResume from "./assignment-resume";
import { laboratoryServices } from "../../services";
import { AuthContext } from "../../context";
const views = [
  { label: "doctors", buttonLabel: "Seleccionar medicos" },
  { label: "products", buttonLabel: "Seleccionar muestras" },
  { label: "assign", buttonLabel: "Asignar muestras" },
  { label: "resume", buttonLabel: "Confirmar asignacion" },
];

const stepsLabel = [
  "1. Seleccionar medicos",
  "2. Seleccionar muestras",
  "3. Asignar a medicos",
  "4. Confirmar",
];
export default function AssignToDoctor() {
  const [toast, setToast] = useState({ open: false, message: "" });
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const { authState } = useContext(AuthContext);

  const {
    doctors,
    changePaginationDoctors,
    paginationDoctors,
    loadingDoctors,
    products,
    paginationProducts,
    changePaginationProducts,
    loadingProducts,
    changeAssignment,
    assignment,
    productsSelected,
    changeProductsSelected,
    doctorsSelected,
    changeDoctorsSelected,
    changeLaboratoryId,
    restoreProductsSelected,
    restoreDoctorsSelected,
    restoreAssignments,
  } = useAssignToDoctor();
  const [view, setView] = useState(0);
  const handleChangeView = (dir) => {
    setView((prev) => {
      if (prev === 0 && dir === "back") return prev;
      if (prev === views.length - 1 && dir === "next") return prev;
      const nextView = dir === "back" ? prev - 1 : prev + 1;
      let errorMessage = null;

      if (
        nextView === 1 &&
        (!doctorsSelected || !Object.keys(doctorsSelected).length)
      )
        errorMessage = "Debe seleccionar al menos un medico";
      if (
        nextView === 2 &&
        (!productsSelected || !Object.keys(productsSelected).length)
      )
        errorMessage = "Debe seleccionar al menos una muestra";

      if (errorMessage) setToast({ open: true, message: errorMessage });
      return errorMessage ? prev : nextView;
    });
  };

  const assignToDoctor = async () => {
    const requestAssignment = flattenAssignments(assignment);
    if (!requestAssignment.length) {
      setToast({ open: true, message: "No tienes asignaciones pendientes." });
      return;
    }

    try {
      setLoading(true);
      const { status, response } =
        await laboratoryServices.assignProductsDoctors({
          token: authState.token,
          assignments: requestAssignment,
        });
      if (status === 200) {
        restoreDoctorsSelected();
        restoreProductsSelected();
        restoreAssignments();
        setView(0);
        setToast({
          open: true,
          message: "Asignacion exitosa",
        });
        return;
      }
      setToast({
        open: true,
        message: response.message,
      });
      return;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  return (
    <Container maxWidth="lg" component={"main"} className={classes.container}>
      {loading && <Loader loading={true} />}
      <Toast
        open={toast.open}
        message={toast.message}
        close={() => setToast({ open: false, message: "" })}
      />
      <Box mt={3} className={classes.steps}>
        {stepsLabel.map((s, index) => (
          <Box
            key={s}
            className={classes.step}
            data-state={index === view ? "active" : "inactive"}
          >
            <Typography>{s}</Typography>
          </Box>
        ))}
      </Box>
      {views[view].label === "doctors" && (
        <DoctorList
          doctors={doctors}
          loading={loadingDoctors}
          changeDoctorsSelected={changeDoctorsSelected}
          doctorsSelected={doctorsSelected}
          page={paginationDoctors.page}
          limit={paginationDoctors.limit}
          count={paginationDoctors.count}
          changePaginationDoctors={changePaginationDoctors}
          restoreDoctorsSelected={restoreDoctorsSelected}
        />
      )}
      {views[view].label === "products" && (
        <SampleList
          products={products}
          count={paginationProducts.count}
          limit={paginationProducts.limit}
          page={paginationProducts.page}
          loading={loadingProducts}
          changePaginationProducts={changePaginationProducts}
          productsSelected={productsSelected}
          changeProductsSelected={changeProductsSelected}
          changeLaboratoryId={changeLaboratoryId}
          restoreProductsSelected={restoreProductsSelected}
        />
      )}
      {views[view].label === "assign" && (
        <AssignList
          assignment={assignment}
          changeAssignment={changeAssignment}
          productsSelected={productsSelected}
          doctorsSelected={doctorsSelected}
        />
      )}
      {views[view].label === "resume" && (
        <AssignmentResume
          assignment={assignment}
          doctorsSelected={doctorsSelected}
          productsSelected={productsSelected}
        />
      )}

      <Box className={classes.steps_controller}>
        <Button
          size="small"
          variant="outlined"
          color="default"
          onClick={() => handleChangeView("back")}
          disabled={view === 0}
        >
          {view === 0 ? "Atras" : views[`${view - 1}`].buttonLabel}
        </Button>
        <Button
          size="small"
          variant={view === views.length - 1 ? "contained" : "outlined"}
          color="primary"
          onClick={() => {
            if (view === views.length - 1) {
              assignToDoctor();
              return;
            }
            handleChangeView("next");
          }}
        >
          {view === views.length - 1
            ? "Confirmar"
            : views[`${view + 1}`].buttonLabel}
        </Button>
      </Box>
    </Container>
  );
}

function flattenAssignments(state) {
  return Object.values(state).flatMap((doctorProducts) =>
    Object.values(doctorProducts)
      .filter((item) => Number(item.qty) > 0)
      .map((item) => ({
        ...item,
        qty: Number(item.qty),
      }))
  );
}
const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  steps: {
    display: "flex",
    height: 32,
  },
  step: {
    display: "flex",
    padding: 6,
    overflow: "hidden",
    borderRight: `1px solid white`,
    alignItems: "center",
    transition: `flex 0.5s ${theme.transitions.easing.easeInOut}`,
    "& > p": {
      color: theme.palette.info.dark,
      fontWeight: 600,
      fontSize: "1.2rem",
      whiteSpace: "nowrap",
      wordBreak: "keep-all",
    },
    '&[data-state="active"]': {
      flex: 1,
      border: `1px solid ${theme.palette.grey[200]}`,

      "& > p": {
        opacity: 1,
        transition: `opacity 0.3s 0.1s ${theme.transitions.easing.easeInOut}`,
      },
    },
    '&[data-state="inactive"]': {
      backgroundColor: `hsl(from ${theme.palette.info.dark} h s calc(44 + l)) `,
      flex: 0,
      "& > p": {
        opacity: 0,
      },
    },
  },
  steps_controller: {
    display: "flex",
    marginTop: theme.spacing(2),
    justifyContent: "space-between",
  },
}));
